var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection } from './utils';
const initialState = {
    data: [],
    count: 0,
    error: null,
    loading: false,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const createAssetFlags = createAsyncThunk('assetFlags/create', (flags_1, _a) => __awaiter(void 0, [flags_1, _a], void 0, function* (flags, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.assetFlags.collection.create(flags);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const deleteAssetFlags = createAsyncThunk('assetFlags/delete', (flags_1, _a) => __awaiter(void 0, [flags_1, _a], void 0, function* (flags, { fulfillWithValue, rejectWithValue }) {
    try {
        const flagsIds = flags.map((flag) => ({ id: flag.id }));
        yield api.assetFlags.collection.delete(flagsIds);
        return fulfillWithValue(flagsIds);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const createAndDeleteAssetFlags = createAsyncThunk('assetFlags/createAndDelete', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ flagsToCreate, flagsToDelete }, { fulfillWithValue, rejectWithValue }) {
    try {
        const flagsToDeleteIds = flagsToDelete.map((flag) => ({ id: flag.id }));
        const toCreate = flagsToCreate.length && api.assetFlags.collection.create(flagsToCreate);
        const toDelete = flagsToDeleteIds.length && api.assetFlags.collection.delete(flagsToDeleteIds);
        const [createdFlags] = yield Promise.all([toCreate, toDelete]);
        return fulfillWithValue({ createdFlags: createdFlags || [], flagsToDeleteIds });
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
// actions for middleware
export const createAssetFlagsAction = createAssetFlags.fulfilled;
export const deleteAssetFlagsAction = deleteAssetFlags.fulfilled;
export const createAndDeleteAssetFlagsAction = createAndDeleteAssetFlags.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxAssetFlags',
    initialState,
    reducers: {
        createAssetFlagsFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (flag) => flag.id);
            state.data = newData;
        },
        deleteAssetFlagsFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = [...state.data].filter((flag) => flag.id !== updatedPayload.id);
            state.data = newData;
        },
        setAllReduxRelAssetFlags: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // CREATE FLAG RELATION
        builder.addCase(createAssetFlags.pending, () => { });
        builder.addCase(createAssetFlagsAction, (state, { payload }) => {
            const t = [...state.data, payload];
            const newData = removeDuplicates(t, (flag) => flag.id);
            state.data = newData;
        });
        builder.addCase(createAssetFlags.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // DELETE FLAG RELATION
        builder.addCase(deleteAssetFlags.pending, () => { });
        builder.addCase(deleteAssetFlagsAction, (state, { payload }) => {
            const idsArr = payload.map((el) => el.id);
            const updatedData = deleteDataFomCollection(state.data, idsArr);
            state.data = updatedData;
        });
        builder.addCase(deleteAssetFlags.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // CREATE AND DELETE FLAG RELATION
        builder.addCase(createAndDeleteAssetFlags.pending, () => { });
        builder.addCase(createAndDeleteAssetFlagsAction, (state, { payload }) => {
            const { createdFlags, flagsToDeleteIds } = payload;
            const idsArr = flagsToDeleteIds.map((el) => el.id);
            const t = [...state.data, ...createdFlags];
            const cleanedData = removeDuplicates(t, (flag) => flag.id);
            const newData = deleteDataFomCollection(cleanedData, idsArr);
            state.data = newData;
        });
        builder.addCase(createAndDeleteAssetFlags.rejected, (state, { payload }) => {
            state.error = payload;
        });
    },
});
export const { setAllReduxRelAssetFlags, createAssetFlagsFromWS, deleteAssetFlagsFromWS } = actions;
export default reducer;
